import {RouteRecordRaw} from 'vue-router';
import {Role} from '../../../records/user.record';

export default function (rootName: string): RouteRecordRaw[] {
    return [
        {
            path: `order/:orderId`,
            name: `${rootName}OrderForm`,
            component: () => import('../../settings/orders/OrderForm.vue'),
            props: (route) => {
                return Object.assign({
                    id: route.params.orderId != 'add' ? route.params.orderId : null,
                    snapshot: rootName != 'orders',
                    backRouteName: rootName,
                    consignment: route.query.consignment,
                    linkedOrder: route.query.linkedOrder,
                    tab: route.query.tab
                });
            },
            meta: {
                roles: [Role.DISPATCHER, Role.ADMIN, Role.CUSTOMER_SERVICE]
            }
        }
    ];
}
